/* eslint-disable no-else-return */
/* eslint-disable max-lines */
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'data': [],
  'listOrders': [],
};

export const floatingInventoryReport = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_FLOATING_INVENTORY_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FLOATING_INVENTORY_REPORT]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'data': action.response.data,
      });
    },
    [ActionTypes.FETCHED_FLOATING_INVENTORY_REPORT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': [],
    }),

    [ActionTypes.CLEAN_FLOATING_INVENTORY_REPORT]: (state, action) => ({
      ...state,
      'loading': false,
      'data': [],
    }),
    
    [ActionTypes.FETCHING_VEHICLES_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'listOrders': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLES_ORDERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'listOrders': [],
    }),

  })(state, action);
};
